/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

// Stroke icons from the console redesign canvas. 24×24, currentColor.

import React from 'react';

type P = React.SVGProps<SVGSVGElement>;
const S: React.FC<P & { children: React.ReactNode }> = ({ children, className, ...rest }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className ?? 'w-[18px] h-[18px] flex-none'}
    {...rest}
  >
    {children}
  </svg>
);

export const HomeIc = (p: P) => <S {...p}><path d="M3 10.5 12 3l9 7.5V21h-6v-6H9v6H3z" /></S>;
export const GridIc = (p: P) => (
  <S {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
  </S>
);
export const ChipIc = (p: P) => (
  <S {...p}>
    <rect x="5" y="5" width="14" height="14" rx="2" /><rect x="9" y="9" width="6" height="6" />
    <path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3" />
  </S>
);
export const TerminalIc = (p: P) => <S {...p}><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M7 9l3 3-3 3M13 15h4" /></S>;
export const DriveIc = (p: P) => <S {...p}><rect x="2" y="13" width="20" height="8" rx="2" /><path d="M5.5 13 8 4h8l2.5 9M6 17h.01M10 17h.01" /></S>;
export const LayersIc = (p: P) => <S {...p}><path d="M12 3 2 8l10 5 10-5z" /><path d="M2 13l10 5 10-5" /></S>;
export const TrendIc = (p: P) => <S {...p}><path d="M3 17l6-6 4 4 8-8" /><path d="M15 7h6v6" /></S>;
export const ServersIc = (p: P) => (
  <S {...p}><rect x="3" y="4" width="18" height="7" rx="1.5" /><rect x="3" y="13" width="18" height="7" rx="1.5" /><path d="M7 7.5h.01M7 16.5h.01" /></S>
);
export const BoltIc = (p: P) => <S {...p}><path d="M13 2 4 14h7l-1 8 9-12h-7z" /></S>;
export const ChatIc = (p: P) => <S {...p}><path d="M4 5h16v11H9l-5 4z" /></S>;
export const KeyIc = (p: P) => <S {...p}><circle cx="8" cy="15" r="4" /><path d="m11 12 9-9M17 6l3 3" /></S>;
export const DbIc = (p: P) => (
  <S {...p}><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 1.7 3.6 3 8 3s8-1.3 8-3V5" /><path d="M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3" /></S>
);
export const FolderIc = (p: P) => <S {...p}><path d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></S>;
export const CardIc = (p: P) => <S {...p}><rect x="3" y="6" width="18" height="14" rx="2" /><path d="M3 10h18M16 15h2" /></S>;
export const SlidersIc = (p: P) => (
  <S {...p}><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" /></S>
);
export const CompassIc = (p: P) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="m15.5 8.5-2 5-5 2 2-5z" /></S>;
export const SearchIc = (p: P) => <S {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></S>;
export const ChevronDownIc = (p: P) => <S {...p}><path d="m6 9 6 6 6-6" /></S>;
export const PlusIc = (p: P) => <S {...p}><path d="M12 5v14M5 12h14" /></S>;
export const MenuIc = (p: P) => <S {...p}><path d="M4 7h16M4 12h16M4 17h16" /></S>;
export const CloseIc = (p: P) => <S {...p}><path d="M6 6l12 12M18 6 6 18" /></S>;
export const ExternalIc = (p: P) => <S {...p}><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" /></S>;
export const BoxIc = (p: P) => <S {...p}><path d="M21 8 12 3 3 8v8l9 5 9-5z" /><path d="M3 8l9 5 9-5M12 13v8" /></S>;
export const ArrowRightIc = (p: P) => <S {...p}><path d="M5 12h14M13 6l6 6-6 6" /></S>;
export const BellIc = (p: P) => <S {...p}><path d="M6 8a6 6 0 1 1 12 0c0 7 3 8 3 8H3s3-1 3-8M10 20a2 2 0 0 0 4 0" /></S>;
export const UsersIc = (p: P) => (
  <S {...p}><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c.6-3.4 3.3-5.5 6.5-5.5s5.9 2.1 6.5 5.5M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.7c1.9.7 3.1 2.6 3.5 5.3" /></S>
);
export const ShieldIc = (p: P) => <S {...p}><path d="M12 3 4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6z" /></S>;
export const LogoutIc = (p: P) => <S {...p}><path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 17l5-5-5-5M15 12H3" /></S>;
export const BookIc = (p: P) => <S {...p}><path d="M4 4h6a2 2 0 0 1 2 2v14a2 2 0 0 0-2-2H4zM20 4h-6a2 2 0 0 0-2 2v14a2 2 0 0 1 2-2h6z" /></S>;
export const SparkIc = (p: P) => <S {...p}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6" /></S>;
